export default __webpack_public_path__ + "static/media/G9.63573876.png";